export default [
    {
        type: "b-form-datepicker",
        margin: true,
        showLabel: true,
        label: "from",
        placeholder: "DATE",
        class: "font-small-2",
        model: null,
        locale: "es",
        dateFormatOptions: { year: 'numeric', month: '2-digit', day: 'numeric' },
        cols: 6,
    },
    {
        type: "b-form-datepicker",
        margin: true,
        showLabel: true,
        label: "to",
        placeholder: "DATE",
        class: "font-small-2",
        model: null,
        locale: "es",
        dateFormatOptions: {
            year: "numeric",
            month: "2-digit",
            day: "numeric",
        },
        cols: 6,
    },
    {
        type: "b-form-select",
        margin: true,
        showLabel: true,
        label: "role",
        options: [
            { value: 1, text: "CEO" },
            { value: 2, text: "CHIEF" },
            { value: 3, text: "SUPERVISOR COVID" },
            { value: 4, text: "SUPERVISOR SECURITY" },
            { value: 5, text: "SUPERVISOR" },
            { value: 6, text: "OPERATOR" },
        ],
        model: null,
        cols: 12,
    },
    {
        type: "b-form-select",
        margin: true,
        showLabel: true,
        label: "campus",
        options: [
            { value: 1, text: "PERÚ" },
            { value: 2, text: "EE.UU" }
        ],
        model: null,
        cols: 6,
    },
    {
        type: "b-form-select",
        margin: true,
        showLabel: true,
        label: "type",
        options: [
            { value: 1, text: "CLIENT" },
            { value: 2, text: "PERSONAL" }
        ],
        model: null,
        cols: 6,
    },
];